import { CoverDrawerDetailsParent } from "@/schema/renewal-page/current-policy-page.schema";
import { CoverLevelBenefits } from "@/schema/renewal-page/middle-panel.schema";

type DefaqtoRatingType = 1 | 2 | 3 | 4 | 5;

export function getCoverLevelBenefits(
  coverLevelBenefits: CoverLevelBenefits,
  coverType: string,
  isCruise?: boolean
) {
  const allBenefits = Object.values(coverLevelBenefits);
  const matched = allBenefits.find((item) => {
    const cruise = item.coverBenefits.isCruise
      ? item.coverBenefits.isCruise
      : false;

    return item.coverBenefits.coverType === coverType && isCruise === cruise;
  });
  return matched?.coverBenefits;
}

export function getCoverLevelInfo(
  coverLevelBenefits: CoverLevelBenefits,
  coverType: string,
  isCruise?: boolean
) {
  const coverBenefits = getCoverLevelBenefits(
    coverLevelBenefits,
    coverType,
    isCruise
  );
  const nodeKeys = coverBenefits?.benefitCopy
    ? Object.keys(coverBenefits.benefitCopy).map((key) => parseInt(key, 10))
    : ([] as number[]);

  return {
    coverTop: {
      coverType,
      defaqtoRating: Number(
        coverBenefits?.defaqtoRating ?? 1
      ) as DefaqtoRatingType,
      coverName: coverBenefits?.coverName,
      whichBestBuyBadge: coverBenefits?.whichBestBuyBadgeImage,
    },
    bottomContent: {
      benefitsCopy: nodeKeys
        .map((key) => coverBenefits?.benefitCopy[key])
        .filter(
          (benefit): benefit is NonNullable<typeof benefit> =>
            benefit !== undefined
        ),
    },
  };
}

export function getCoverLevelSeeMoreDetails(
  data: CoverDrawerDetailsParent,
  coverType: string,
  isCruise?: boolean
) {
  const allSeeMoreDrawerDetails = Object.values(data);
  const seeMoreDrawerDetails = allSeeMoreDrawerDetails.find((item) => {
    const cruise = item.seeMoreDrawerDetails.isCruise
      ? item.seeMoreDrawerDetails.isCruise
      : false;
    return (
      item.seeMoreDrawerDetails?.coverType === coverType && isCruise === cruise
    );
  });
  return seeMoreDrawerDetails;
}

export function getSeeMoreDetailsInfo(
  data: CoverDrawerDetailsParent,
  currentPolicy: string,
  isCruise?: boolean
) {
  if (!data) {
    return {
      coverLevelTitle: "",
      drawerCopy: "",
      drawerData: [],
    };
  }

  const seeMoreDrawerDetails = getCoverLevelSeeMoreDetails(
    data,
    currentPolicy,
    isCruise
  );

  const nodes: string[] = Object.entries(
    seeMoreDrawerDetails?.seeMoreDrawerDetails?.coverDrawerDetails || {}
  )
    .filter(
      ([, value]) =>
        typeof value === "object" && value !== null && !Array.isArray(value)
    )
    .map(([key]) => key);

  const drawerData = nodes
    .map(
      (node) =>
        seeMoreDrawerDetails?.seeMoreDrawerDetails.coverDrawerDetails[node]
    )
    .filter(
      (drawer): drawer is NonNullable<typeof drawer> => drawer !== undefined
    );

  return {
    closeDrawerCta:
      seeMoreDrawerDetails?.seeMoreDrawerDetails?.drawerCloseCta ?? "Close",
    coverLevelTitle: seeMoreDrawerDetails?.seeMoreDrawerDetails.coverName ?? "",
    drawerCopy:
      seeMoreDrawerDetails?.seeMoreDrawerDetails.coverDrawerCopy ?? "",
    drawerData,
  };
}
